import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'dateNoTimezone',
  standalone: false,
})
export class DateNoTimezonePipe implements PipeTransform {
  // NOTE: assumes date is in ISO format
  transform(date: string | null | undefined, args?: string): string {
    if (!date) return ''; // Return an empty string

    const dateNoTimezone = date.substring(0, 16);
    return moment(dateNoTimezone).format(args);
  }
}
